import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "stats-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = { class: "stats-container" }
const _hoisted_5 = { class: "stat-number" }
const _hoisted_6 = { class: "stat-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('home.platformAchievements')), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stats, (stat, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "stat-item",
            style: _normalizeStyle({ animationDelay: `${index * 0.1}s` })
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(stat.value) + "+ ", 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(stat.label), 1)
          ], 4))
        }), 128))
      ])
    ])
  ]))
}